import React from 'react';
import { Tag } from 'antd';
import type { TaskHistoryItem, TaskHistoryTerminalStatus } from '../../types/taskHistory';
import {
  TASK_STATUS_BADGE_CONFIG,
  type TaskStatusBadgeKey
} from './taskStatusColors';

export interface TaskStatusBadgeProps {
  status: TaskStatusBadgeKey | TaskHistoryTerminalStatus | string;
}

export function resolveTaskHistoryDisplayStatus(
  item: Pick<TaskHistoryItem, 'status' | 'completedByUserId' | 'completedByUserName'>
): TaskStatusBadgeKey {
  const status = String(item.status || '').toUpperCase();
  if (status === 'CANCELLED') return 'CANCELLED';
  if (status === 'OVERDUE') return 'OVERDUE';
  if (status === 'SKIPPED') return 'SKIPPED';
  if (
    status === 'DONE' &&
    item.completedByUserId == null &&
    String(item.completedByUserName || '').trim() === 'Система'
  ) {
    return 'AUTO_DONE';
  }
  if (status === 'DONE') return 'DONE';
  return 'DONE';
}

const TaskStatusBadge: React.FC<TaskStatusBadgeProps> = ({ status }) => {
  const key = String(status || '').toUpperCase() as TaskStatusBadgeKey;
  const cfg = TASK_STATUS_BADGE_CONFIG[key];
  if (!cfg) {
    return (
      <Tag color="default" style={{ marginInlineEnd: 0 }}>
        —
      </Tag>
    );
  }
  return (
    <Tag color={cfg.color} style={{ marginInlineEnd: 0 }}>
      {cfg.label}
    </Tag>
  );
};

export default TaskStatusBadge;
